<template>
  <div class="main">
    <report-top>
      <ly-search slot="search" v-model="searchItem.keyWork" @search="search"></ly-search></report-top>
    <selectTool ref="selectTool"><template slot="btn"><Button @click="getSearchItem" type="error"
          class="chaxun">查询</Button><Button @click="openAdd" type="primary" class="chaxun">新增</Button><Button
          @click="exportAll" v-if="false" type="success" class="chaxun">导出</Button></template>
    </selectTool>

    <Table border :columns="columns" :data="tableData" no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)">

      <viewer slot-scope="{ row, index }" slot="pic">
        <img v-for="(x, index) in row.filesPathArr" :key="index" :src="axios.platConfig.fileUri + x" width="24"
          height="24" style="margin-right: 4px; cursor: pointer" />
      </viewer>
      <ul style="margin-bottom: 10px;" slot-scope="{ row, index }" slot="itemList">
        <li v-for="(x, index) in row.itemList" :key="index">
          <p>{{ x.reason }}：{{ x.money }}元</p>
        </li>
      </ul>
      <template slot-scope="{ row, index }" slot="liucheng">
        <Button v-if="row.flowStartId == null" size="small" @click="addFlow(row)">发起流程</Button>
        <span v-else>{{ row.flowName }}</span>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" :disabled="row.flowStartId == null" @click="openJincheng(row)">进程</Button>
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" :disabled="row.flowStartId != null" @click="del(row, 1)">删除</Button>
        <Button size="small" @click="print(row)">打印</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page :current="1" :total="total" :page-size="searchItem.pageSize" :page-size-opts="[10, 50, 100]" show-total
          show-elevator show-sizer @on-change="changePage" @on-page-size-change="pageSizeChange"></Page>
      </div>
    </div>
    <form-model :title="isAdd ? '新增报销申请' : '编辑报销申请'" width="700" ref="formModel">
      <Input v-model="item.ono" placeholder="请选择" slot="ono" @on-focus="openForm = true"></Input>
      <tableForm slot="itemList" ref="itemList" :forms="itemListForms" :item1="itemListItem" v-model="item.itemList">
      </tableForm>
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
    <createdFlow tag="报销申请" ref="createdFlow" @ok="getList"></createdFlow>
    <jincheng ref="jincheng"></jincheng>
    <printPdf ref="printPdf"></printPdf>
    <Modal v-model="openForm" title="订单号" footer-hide fullscreen width="1000">
      <dingdanhao :scan="true" @obj="
        item.ono = $event.no;
      openForm = false;
      " v-if="openForm"></dingdanhao>
    </Modal>
  </div>
</template>
<script>
import createdFlow from "./createdFlow.vue";
import jincheng from "./jincheng.vue";
import fields from "./fields";
import dingdanhao from "../fahuo/xitongkaidan.vue";
import printPdf from "./PrintPdf.vue";
var flows = [];
var status = {
  0: '草稿',
  1: '流转中',
  2: '已办结',
};
var statues = [];
for (const i in status) {
  statues.push({
    id: i,
    name: status[i]
  })
}
export default {
  components: { createdFlow, jincheng, dingdanhao,printPdf },
  data() {
    return {
      isAdd: false,
      openForm: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
          sort: 0,
        },
        {
          title: "流水号",
          key: "no",
          sort: 0.1,
          width: 130
        },
        {
          title: "总金额",
          key: "money",
          sort: 2.2,
          width: 130
        },
        {
          title: "流程名称",
          slot: "liucheng",
          maxWidth: 300,
          minWidth: 100,
          sort: 1.1,
        },
        {
          title: "流程状态",
          key: "status2",
          maxWidth: 300,
          minWidth: 100,
          sort: 1.1,
        },
        {
          title: "创建时间",
          key: "createTime2",
          sort: 100,
          width: 130,
        },
        {
          title: "操作",
          slot: "action",
          sort: 200,
          width: 200,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        "customer": "",
        "itemList": [],
        "moneyBorrow": 0,
        "imgPaths": "",
        "remark": "",
        "ono": "",
        filesPathArr: []
      },
      forms: fields.baoxiaoshenqing,
      searchItem: {
        "pageNumber": 1,
        "pageSize": 50,
        "startTime": "",
        "endTime": "",
        "no": "",
        "ono": "",
        "flowId": "",
        "keyWork": ""
      },
      searchForms: [
        {
          title: "支付时间",
          key: "startTime",
          key1: "endTime",
          type: "lyyymmdd",
          times: "4,2,0",
        },
        {
          title: "流水号",
          key: "no",
          type: "Input",
        },
        {
          title: "选择流程",
          key: "flowId",
          type: "Select",
          selectType: 'obj',
          selectItems: flows,
          times: "2,0",
        },
        {
          title: "订单号",
          key: "ono",
          type: "Input",
        },
        {
          title: "流程状态",
          key: "status",
          type: "Select",
          selectType: 'obj',
          selectItems: statues,
        },
      ],
      total: 0,

      itemListForms: [
        {
          title: "报销用途",
          key: "reason",
          type: "Input",
          required: true,
        },
        {
          title: "金额",
          key: "money",
          type: "InputNumber",
          required: true,
        },
      ],
      itemListItem: {
        "reason": "",
        "money": 0
      }
    };
  },
  methods: {
    getList() {
     
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-fms/bxApply/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;

        for (const i in data) {
          data[i].payTime2 = this.utils.time(data[i].payTime, 'yymmdd');
          data[i].createTime2 = this.utils.time(data[i].createTime);
          data[i].filesPathArr = this.utils.isEmpty(data[i].imgPaths)
            ? []
            : JSON.parse(data[i].imgPaths);
            data[i].status2=status[data[i].status]
        }
        this.tableData = data;
        console.log(data);
      });
    },
    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      this.item.imgPaths = JSON.stringify(this.item.filesPathArr);
      if (this.isAdd) {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-fms/bxApply/add",
          data: this.item,
        }).then((res) => {
          console.log(res);
          this.$refs.formModel.close();
          var data = res.data.data;
          this.getList();
          this.addFlow(data);
        });
      } else {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-fms/bxApply/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.ipPort + "/cloud-tms-server-fms/bxApply/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    addFlow(data) {
      console.log(data);
      var obj = {
        flowId: '',
        id: data.id,
        no: data.no,
        groupId: data.groupId,
        formId: 'baoxiaoshenqing', //模板id,
      };
      this.$refs.createdFlow.reach(obj);


    },
    //点击编辑按钮
    opemUpdate(row) {
      this.isAdd = false;
      for (const i in this.item) {
        this.item[i] = row[i];
      }
      this.item.id = row.id;
      this.$refs.formModel.reach(this.forms, this.item);
    },
    openAdd() {
      this.isAdd = true;
      this.$refs.formModel.reach(this.forms, this.item);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },

    selectCartype(x) {
      this.selectIcon = x.value;
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
    openJincheng(row) {
      this.$refs.jincheng.reach(row);
    },
    getFlows() {
      this.axios({
        method: "post",
        url: this.axios.flow + "/flowConfig/list",
        data: {},
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        flows.length = 0;
        for (let i = 0; i < data.length; i++) {
          //console.log(data[i].tag.includes("付款申请"));
          var obj = {
            id: data[i].id,
            name: data[i].name
          }

          if (data[i].tag.includes("报销申请")) {
            flows.push(obj)
          }

        }
      });
    },
    exportAll() {
      var params = [

        {
          name: "startTime",
          value: this.searchItem.startTime,
        },
        {
          name: "endTime",
          value: this.searchItem.endTime,
        },
      ];
      this.utils.exportData(this.axios.ipPort + "/cloud-tms-server-fms/bxApply/export", params);
    },
    print(row) {
      this.utils.loading(this, "打印中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-fms/bxApply/print",
        data: {
          "id": row.id
        },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载

        row.src = this.axios.platConfig.fileUri + res.data.data.path;
        //window.open(row.src);
        this.$refs.printPdf.reach(row)
      });
    }
  },
  mounted() {
    var config = {
      min: 100,
      max: 300,
    };
    this.columns = this.utils.cols(this.forms, this.columns, config);
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 200);
    this.getFlows();
  },
};
</script>
<style></style>


// WEBPACK FOOTER //
// src/components/wuliu/caiwufeiyong/baoxiaoshenqing.vue